import React, { useRef } from "react"
import { useEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom";
import store, { type RootState } from "../../../global/config/store.ts"
import { Box, Button, TextField, } from "@mui/material";
import { setLoadingFalse, setLoadingTrue } from "../../../global/config/Action/loadingActions.ts"
import imageCompression from "browser-image-compression"
import { CustomUploadProfilePic } from "../../../apiService/Core/CustomUploadProfilePic.tsx"
import { toast } from "react-toastify";
import { Upload } from "@mui/icons-material";
import { ApicreateAirTasker, ApiGetAirTaskerShopperList, ApiupdateAirTasker } from "../../../apiService/Core/Apicall.tsx";
import { Formik } from "formik";

const AirTasker: React.FC = () => {

    const { mode = "add", id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    // const shopperDetails = location?.state?.shopperDetails;
    const [shopperDetails, setshopperDetails] = useState<any>([])

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        emailId: "",
        contactNo: "",
        city: "",
        state: "",
        dob: "",
        gender: "",
        isAirTasker: true,
        driving_licence: ""
    })
    const [licenceImage, setlicenceImage] = useState<string | null>(null)
    const [errors, setErrors] = useState<{ [key: string]: string }>({})
    const inputRef = useRef<HTMLInputElement>(null);
    const autocompleteRef = useRef<any>(null);
    const [inputValue, setInputValue] = useState("");


    const handleGetApiCall = async (status?: string) => {
        try {
            const data = `?userId=${id}`
            const res = await ApiGetAirTaskerShopperList(data)
            setshopperDetails(res.data[0])

        } catch (error) {
            console.error("Error during API call:", error)
        }
    }

    useEffect(() => {
        id && handleGetApiCall()
    }, [id])


    useEffect(() => {
        if (mode === "update" && shopperDetails) {
            setInputValue(`${shopperDetails.city},${shopperDetails.state}`)
            setFormData({
                firstName: shopperDetails.firstName || "",
                lastName: shopperDetails.lastName || "",
                emailId: shopperDetails.emailId || "",
                contactNo: shopperDetails.contactNo || "",
                city: shopperDetails.city || "",
                state: shopperDetails.state || "",
                dob: shopperDetails.dob || "",
                gender: shopperDetails.gender || "",
                isAirTasker: true,
                driving_licence: shopperDetails.profilePicUrl || "",
            });
            setlicenceImage(shopperDetails.profilePicUrl || null);
        }
    }, [mode, shopperDetails]);

    const validateEmail = (email: string): boolean => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    const validateMobileNumber = (mobile: string): boolean => {
        const cleanedMobile = mobile.replace(/[\s\-\(\)]/g, '');

        const mobileRegex = /^\d{10}$/;

        return mobileRegex.test(cleanedMobile);
    }


    const validateForm = (): boolean => {
        const newErrors: { [key: string]: string } = {};

        if (!formData.firstName.trim()) {
            newErrors.firstName = "First name is required";
        }

        if (!formData.lastName.trim()) {
            newErrors.lastName = "Last name is required";
        }

        if (!formData.emailId.trim()) {
            newErrors.emailId = "Email is required";
        } else if (!validateEmail(formData.emailId)) {
            newErrors.emailId = "Please enter a valid email address";
        }

        if (!formData.contactNo.trim()) {
            newErrors.contactNo = "Mobile number is required";
        } else if (!validateMobileNumber(formData.contactNo)) {
            newErrors.contactNo = "Please enter a valid 10-digit mobile number";
        }

        if (!formData.city.trim()) {
            newErrors.city = "City is required";
        }
        if (!formData.state.trim()) {
            newErrors.state = "state is required";
        }

        if (!formData.dob) {
            newErrors.dob = "Date of birth is required";
        } else {
            const dobDate = new Date(formData.dob);
            const today = new Date();
            const age = today.getFullYear() - dobDate.getFullYear();
        }

        if (!formData.gender) {
            newErrors.gender = "Please select a gender";
        }

        if (!licenceImage) {
            newErrors.licenceImage = "Profile photo is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }


    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }))
        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: ""
            }))
        }
    }

    const handleRadioChange = (name: string, value: string) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }))
        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: ""
            }))
        }
    }

    const handlelicenceImageUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null
        if (file) {
            store.dispatch(setLoadingTrue())
            try {
                // Compression options
                const options = {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 1024,
                    useWebWorker: true,
                }

                const compressedFile = await imageCompression(file, options)

                // Upload compressed file
                uploadImage(compressedFile)
            } catch (error) {
                console.error("Image compression failed:", error)
                store.dispatch(setLoadingFalse())
            }
        }
    }

    const uploadImage = async (file: File) => {
        store.dispatch(setLoadingTrue())
        // console.log("FIle", file)
        const formData = new FormData()
        formData.append("file", file)
        formData.append("fileType", "profile_pic")
        formData.append("userId", shopperDetails?.userId)

        // console.log("file", file)

        try {
            const response = await CustomUploadProfilePic(formData)
            store.dispatch(setLoadingFalse())
            toast.success("File uploaded successfully")
            setlicenceImage(response.location)
        } catch (error) {
            console.error("Error uploading file:", error)
            toast.error(error)
        }
    }
    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }

        const payload = {
            ...formData,
            driving_licence: licenceImage,
        };
        console.log("Payload --->", payload)

        try {
            if (mode === "add") {
                await ApicreateAirTasker(payload);
                toast.success("AirTasker created successfully");
            } else {
                await ApiupdateAirTasker({ ...payload, userId: shopperDetails.userId });
                toast.success("AirTasker updated successfully");
            }
            navigate(-1);
        } catch (error: any) {
            const apiMessage =
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                error?.message ||
                "Something went wrong";

            toast.error(apiMessage);
            console.error("Error:", error);
        }
    };

    const formStyles = {
        container: {
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "20px",
            borderRadius: '10px',
            fontFamily: "Arial, sans-serif",
            backgroundColor: "#fff",
        },
        section: {
            marginBottom: "30px",
            borderBottom: "1px solid #f0f0f0",
            paddingBottom: "20px",
        },
        sectionTitle: {
            fontSize: "18px",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "5px",
            display: "flex",
            alignItems: "center",
        },
        sectionNumber: {
            marginRight: "8px",
        },
        sectionDescription: {
            fontSize: "14px",
            color: "#666",
            marginBottom: "15px",
        },
        formRow: {
            display: "flex",
            flexWrap: "wrap",
            margin: "0 -10px",
            marginBottom: "15px",
        },
        formColumn: {
            flex: "1 0 calc(50% - 20px)",
            margin: "0 10px",
            minWidth: "250px",
        },
        formColumnFull: {
            flex: "1 0 calc(100% - 20px)",
            margin: "0 10px",
        },
        inputLabel: {
            display: "block",
            fontSize: "14px",
            marginBottom: "5px",
            color: "#333",
        },
        requiredStar: {
            color: "red",
            marginLeft: "2px",
        },
        textField: {
            width: "100%",
            padding: "8px 12px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            fontSize: "14px",
            boxSizing: "border-box",
        },
        radioGroup: {
            display: "flex",
            alignItems: "center",
            marginTop: "5px",
        },
        radioLabel: {
            marginRight: "20px",
            display: "flex",
            alignItems: "center",
            fontSize: "14px",
        },
        radioInput: {
            marginRight: "5px",
            width: "16px",
            height: "16px",
            accentColor: "#1976d2",
            cursor: "pointer",
        },
        uploadBox: {
            border: "1px dashed #ccc",
            borderRadius: "4px",
            height: "200px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            width: "50%",
            position: "relative" as const,
        },
        uploadIcon: {
            fontSize: "24px",
            color: "#666",
            marginBottom: "8px",
        },
        uploadText: {
            fontSize: "14px",
            color: "#666",
        },
        fileInput: {
            position: "absolute" as const,
            width: "100%",
            height: "100%",
            opacity: 0,
            cursor: "pointer",
        },
        buttonContainer: {
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            marginTop: "20px",
        },
        textFieldError: {
            width: "100%",
            padding: "8px 12px",
            border: "1px solid #f44336",
            borderRadius: "4px",
            fontSize: "14px",
            boxSizing: "border-box",
        },
        errorText: {
            color: "#f44336",
            fontSize: "12px",
            marginTop: "4px",
        },
        uploadBoxError: {
            border: "1px dashed #f44336",
            borderRadius: "4px",
            height: "200px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            width: "50%",
            position: "relative" as const,
        },
    };

    useEffect(() => {
        const loadAutocomplete = async () => {
            // Add a small delay to ensure the input is rendered
            setTimeout(() => {
                if (!window.google) {
                    console.error("Google Maps API is not loaded.");
                    return;
                }

                if (!inputRef.current) {
                    console.error("Input reference is null.");
                    return;
                }

                try {
                    autocompleteRef.current = new window.google.maps.places.Autocomplete(
                        inputRef.current,
                        {
                            // types: ["geocode"],
                            types: ["(cities)"],
                            componentRestrictions: { country: "AU" },
                        }
                    );

                    autocompleteRef.current.addListener("place_changed", async () => {
                        const place = autocompleteRef.current.getPlace();

                        if (!place || !place.formatted_address) {
                            console.warn("No address found.");
                            return;
                        }
                        let city = "";
                        let state = "";

                        place.address_components.forEach((component: any) => {
                            const types = component.types;

                            if (types.includes("locality")) {
                                city = component.long_name;
                            }

                            if (types.includes("administrative_area_level_1")) {
                                state = component.short_name;
                            }
                        });

                        setInputValue(`${city}, ${state}`);

                        setFormData((prev) => ({
                            ...prev,
                            state: state,
                            city: city,
                        }));
                    });
                } catch (error) {
                    console.error("Error initializing autocomplete:", error);
                }
            }, 100);
        };

        loadAutocomplete();
    }, []);

    console.log("Form Data", formData)

    return (
        <Box className='w-100 p-2'>
            <Box sx={formStyles.container}>
                <Box sx={formStyles.section}>
                    <Box sx={formStyles.sectionTitle}>
                        <span style={formStyles.sectionNumber}>1.</span> Personal Details
                    </Box>
                    <Box><span style={formStyles.sectionDescription}>Tell us a little about yourself.</span></Box>
                </Box>
                <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                    <Box sx={{ flex: "1 1 65%", paddingRight: "20px" }}>
                        <Box sx={formStyles.formRow}>
                            <Box sx={formStyles.formColumn}>
                                <label style={formStyles.inputLabel}>
                                    First Name <span style={formStyles.requiredStar}>*</span>
                                </label>
                                <input
                                    type="text"
                                    name="firstName"
                                    style={formStyles.textField}
                                    value={formData.firstName}
                                    onChange={handleInputChange}
                                />
                                {errors.firstName && <div style={formStyles.errorText}>{errors.firstName}</div>}
                            </Box>
                            <Box sx={formStyles.formColumn}>
                                <label style={formStyles.inputLabel}>
                                    Last Name <span style={formStyles.requiredStar}>*</span>
                                </label>
                                <input
                                    type="text"
                                    name="lastName"
                                    style={formStyles.textField}
                                    value={formData.lastName}
                                    onChange={handleInputChange}
                                />
                                {errors.lastName && <div style={formStyles.errorText}>{errors.lastName}</div>}
                            </Box>
                        </Box>
                        <Box sx={formStyles.formRow}>
                            <Box sx={formStyles.formColumn}>
                                <label style={formStyles.inputLabel}>
                                    Email <span style={formStyles.requiredStar}>*</span>
                                </label>
                                <input
                                    type="email"
                                    name="emailId"
                                    style={formStyles.textField}
                                    value={formData.emailId}
                                    onChange={handleInputChange}
                                    disabled={mode === "update"}
                                />
                                {errors.emailId && <div style={formStyles.errorText}>{errors.emailId}</div>}
                            </Box>
                            <Box sx={formStyles.formColumn}>
                                <label style={formStyles.inputLabel}>
                                    Mobile <span style={formStyles.requiredStar}>*</span>
                                </label>
                                <input
                                    type="text"
                                    name="contactNo"
                                    style={formStyles.textField}
                                    value={formData.contactNo}
                                    onChange={handleInputChange}
                                />
                                {errors.contactNo && <div style={formStyles.errorText}>{errors.contactNo}</div>}
                            </Box>
                        </Box>
                        <Box sx={formStyles.formRow}>
                            {/* <TextField
                                inputRef={inputRef}
                                type="text"
                                value={inputValue}
                                onChange={(e) => setInputValue(e.target.value)}
                                placeholder="Enter address"
                                sx={{
                                    "& .MuiOutlinedInput-root": { padding: "5px" },
                                    width: { xs: "100%", md: "calc(100% - 220px)" }
                                }}
                            /> */}
                            <Box sx={formStyles.formColumn}>
                                <label style={formStyles.inputLabel}>
                                    City <span style={formStyles.requiredStar}>*</span>
                                </label>
                                <input
                                    ref={inputRef}
                                    type="text"
                                    name="city"
                                    style={formStyles.textField}
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value)}
                                />
                                {errors.city && <div style={formStyles.errorText}>{errors.city}</div>}
                            </Box>
                        </Box>
                        <Box sx={formStyles.formRow}>
                            <Box sx={formStyles.formColumn}>
                                <label style={formStyles.inputLabel}>
                                    D.O.B <span style={formStyles.requiredStar}>*</span>
                                </label>
                                <input
                                    type="date"
                                    name="dob"
                                    style={formStyles.textField}
                                    value={formData.dob}
                                    onChange={handleInputChange}
                                />
                                {errors.dob && <div style={formStyles.errorText}>{errors.dob}</div>}
                            </Box>
                            <Box sx={formStyles.formColumn}>
                                <label style={formStyles.inputLabel}>
                                    Gender <span style={formStyles.requiredStar}>*</span>
                                </label>
                                <Box sx={formStyles.radioGroup}>
                                    <label style={formStyles.radioLabel}>
                                        <input
                                            type="radio"
                                            name="gender"
                                            style={formStyles.radioInput}
                                            checked={formData.gender === "Male"}
                                            onChange={() => handleRadioChange("gender", "Male")}
                                        />
                                        Male
                                    </label>
                                    <label style={formStyles.radioLabel}>
                                        <input
                                            type="radio"
                                            name="gender"
                                            style={formStyles.radioInput}
                                            checked={formData.gender === "Female"}
                                            onChange={() => handleRadioChange("gender", "Female")}
                                        />
                                        Female
                                    </label>
                                </Box>
                                {errors.gender && <div style={formStyles.errorText}>{errors.gender}</div>}
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ flex: "1 1 35%" }}>
                        <label style={formStyles.inputLabel}>
                            Profile Picture/Photo ID
                        </label>
                        <Box sx={formStyles.uploadBox}>
                            {licenceImage ? (
                                <img
                                    src={licenceImage || "/placeholder.svg"}
                                    alt="Profile"
                                    style={{
                                        maxHeight: "100%",
                                        maxWidth: "100%",
                                        objectFit: "contain",
                                    }}
                                />
                            ) : (
                                <>
                                    <Box sx={formStyles.uploadIcon}>
                                        <Upload />
                                    </Box>
                                    <Box style={formStyles.uploadText}>Upload Here</Box>
                                </>
                            )}
                            <input type="file" accept="image/*" style={formStyles.fileInput} onChange={handlelicenceImageUpload} />
                        </Box>
                        {errors.licenceImage && (
                            <div style={formStyles.errorText}>{errors.licenceImage}</div>
                        )}
                    </Box>
                </Box>
                <Box style={formStyles.buttonContainer}>
                    <Button variant="contained" className="table-row-background" onClick={handleSubmit}>
                        {mode === "add" ? "Add AirTasker" : "Update AirTasker"}
                    </Button>
                </Box>
            </Box >
        </Box>
    )
}
export default AirTasker;